/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Voucher,
    VoucherFromJSON,
    VoucherFromJSONTyped,
    VoucherToJSON,
} from './';

/**
 * 
 * @export
 * @interface VoucherDataFrame
 */
export interface VoucherDataFrame {
    /**
     * 
     * @type {number}
     * @memberof VoucherDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof VoucherDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof VoucherDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Voucher>}
     * @memberof VoucherDataFrame
     */
    data: Array<Voucher>;
}

export function VoucherDataFrameFromJSON(json: any): VoucherDataFrame {
    return VoucherDataFrameFromJSONTyped(json, false);
}

export function VoucherDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoucherDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(VoucherFromJSON)),
    };
}

export function VoucherDataFrameToJSON(value?: VoucherDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(VoucherToJSON)),
    };
}


